import React from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebaseConfig';
import { signOut } from 'firebase/auth';
import styles from './PaywallModal.module.css';

/**
 * PaywallModal Component
 * 
 * A server-controlled modal overlay that blocks user interaction with page content
 * for users without active subscriptions. This modal cannot be bypassed through
 * frontend manipulation as it renders based on server API response.
 * 
 * Features:
 * - Covers entire page with overlay
 * - Centered modal with margins
 * - Blocks all page interaction
 * - Subscribe and Logout options
 * - Professional appearance similar to Chegg's paywall
 */
const PaywallModal = () => {
  const navigate = useNavigate();

  /**
   * Handle subscription button click
   * Navigates user to subscription page
   */
  const handleSubscribe = () => {
    navigate('/subscribe');
  };

  /**
   * Handle logout button click
   * Signs out user and redirects to login
   */
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
      // Fallback redirect
      navigate('/login');
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Subscription Required</h2>
          <p className={styles.modalSubtitle}>
            You need an active subscription to access this feature
          </p>
        </div>
        
        <div className={styles.modalBody}>
          <p className={styles.modalDescription}>
            To continue using our document processing services, please subscribe to one of our plans.
          </p>
          
          <div className={styles.featureList}>
            <div className={styles.featureItem}>
              <span className={styles.featureIcon}>📄</span>
              <span>Process your enterprise documents</span>
            </div>
            <div className={styles.featureItem}>
              <span className={styles.featureIcon}>🔒</span>
              <span>Secure data processing</span>
            </div>
            <div className={styles.featureItem}>
              <span className={styles.featureIcon}>⚡</span>
              <span>Fast AI-powered extraction</span>
            </div>
          </div>
        </div>
        
        <div className={styles.modalActions}>
          <button 
            className={`${styles.button} ${styles.primaryButton}`}
            onClick={handleSubscribe}
          >
            Subscribe Now
          </button>
          <button 
            className={`${styles.button} ${styles.secondaryButton}`}
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaywallModal;
